<template>
    <v-app style="background: #eeeeee;">
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                :absolute=true
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <NavAdministration 
            @LoadOrder=LoadOrder 
            @LoadCompany=LoadCompany 
        />
        <v-main v-if="accessAdmin"
            :style="{'background-image': 'url(' + require('../../../assets/back2.jpg') + ')'}"
        >
            <v-container fluid style="opacity:1">  
                <v-card >
                    <div v-if=listOrders>
                        <v-col cols="12">
                        <v-row>
                            <v-col
                                cols="12"
                                sm="3"
                                class="py-0"
                            >
                                <v-menu>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateRangeText"
                                            label="Fechas"
                                            persistent-hint
                                            readonly
                                            append-icon="mdi-calendar-multiple"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        range
                                        v-model="dates"
                                        no-title
                                        @input="menu = false"
                                        @change="searchDataTable"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="3"
                                class="py-0"
                            >
                                <v-autocomplete
                                    v-model=company
                                    :items=companies
                                    item-value="party_id"
                                    item-text="name"
                                    prepend-icon="mdi-hospital-building"
                                    @change="searchDataTable"
                                ></v-autocomplete>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="3"
                                class="py-0"
                            >
                                <v-select
                                    label="Estado"
                                    v-model=stateListOrder
                                    :items= statesListOrder
                                    item-value="status_id"
                                    item-text="name"
                                    prepend-icon="mdi-clock-alert"
                                    @change="searchDataTable"
                                >
                                </v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="3"
                                class="py-0"
                            >
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                    @click:append=getDataComponent
                                ></v-text-field>
                            </v-col>
                            </v-row>
                        </v-col>
                        <v-data-table
                            :headers=headers
                            :items=dataTable
                            :options.sync=options
                            :server-items-length=totalItems
                            :loading=loadingTable
                            :search=search
                            class="elevation-3"
                        >
                        <template v-slot:item.action="{ item }")>
                            <v-icon 
                                @click="detailOrder(item)"
                                v-if="item.status_id_order != 'OLST_CANCELADA'"
                            >
                                mdi-file-document
                            </v-icon>
                            <StatusOrderComponent 
                                v-if="item.status_id_order != 'OLST_COMPLETADA'"
                                :status=item.status_id_order
                                :idOrder=parseInt(item.olab_id)
                                @setOverlay = setOverlay
                                @updateStatusOrder = updateStatusOrder
                            />
                        </template>
                        <template v-slot:item.quote_id="{ item }">
                            <a  
                                target="_blank" 
                                :href="`https://innoclinica.evalua.com.ec/ventas/control/verCotizacion2?quoteId=${item.quote_id}`">{{item.quote_id}}
                            </a>
                        </template>
                        <!-- <template v-slot:item.cotizar="{ item }">
                            <v-simple-checkbox 
                                v-model="item.cot" 
                                v-if=item.cotizar
                            >
                            </v-simple-checkbox>
                        </template>     -->
                        <!-- <template v-slot:footer>
                            <div cols="12" class="text-center">
                                <v-btn 
                                    small 
                                    color="primary" 
                                    v-if=cotizar 
                                >
                                    <v-icon>mdi-cube-send</v-icon> Realizar cotización
                                </v-btn>
                            </div>
                        </template>    -->                 
                        </v-data-table>
                        <DetailOrderComponent
                            :dialogOrder=dialogOrder
                            :dataDetailOrder=dataDetailOrder
                            :state=state
                            :overlay=overlay
                            @closeDialog =closeDialog
                            @setFileC = setFileCharge
                            @setOverlay= setOverlay
                            @setState = setState
                            @storeFile = storeFile
                        />
                        <!-- <v-dialog 
                            v-model="dialogOrder" 
                            max-width="1000px"
                            persistent
                        >
                            <v-card>
                                <v-overlay :value="overlay">
                                    <v-progress-circular
                                        indeterminate
                                        :absolute=true
                                        size="64"
                                    ></v-progress-circular>
                                </v-overlay>
                                <v-card-title>
                                <span class="headline">Detalle de la orden </span>
                                </v-card-title>
                                <v-card-text class="px-0">
                                    <v-container fluid>
                                        <v-row>
                                            <v-col 
                                                cols="12"
                                                md="4"
                                                style="border-right:1px solid silver"
                                            >
                                                <v-list class="py-0">
                                                    <v-list-item >
                                                        <v-list-item-avatar  >
                                                        <v-icon color="primary">mdi-36px mdi-checkbox-multiple-marked-outline</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Orden</v-list-item-title>
                                                        <v-list-item-subtitle>{{dataDetailOrder.order}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list class="py-0">
                                                    <v-list-item>
                                                        <v-list-item-avatar  >
                                                        <v-icon color="primary">mdi-36px mdi-account-circle</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Paciente</v-list-item-title>
                                                        <v-list-item-subtitle>{{dataDetailOrder.patient}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list class="py-0">
                                                    <v-list-item>
                                                        <v-list-item-avatar  >
                                                        <v-icon color="primary">mdi-36px mdi-account-box-outline</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Identificación</v-list-item-title>
                                                        <v-list-item-subtitle>{{dataDetailOrder.identification}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list class="py-0">
                                                    <v-list-item
                                                        
                                                    >
                                                        <v-list-item-avatar >
                                                        <v-icon color="primary">mdi-36px mdi-account-star</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Médico</v-list-item-title>
                                                        <v-list-item-subtitle>{{dataDetailOrder.doctor}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list class="py-0">
                                                    <v-list-item >
                                                        <v-list-item-avatar >
                                                        <v-icon color="primary">mdi-36px mdi-calendar</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Fecha</v-list-item-title>
                                                        <v-list-item-subtitle>{{dataDetailOrder.date}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list class="py-0">
                                                    <v-list-item >
                                                        <v-list-item-avatar >
                                                        <v-icon color="primary">mdi-36px mdi-city</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Empresa</v-list-item-title>
                                                        <v-list-item-subtitle>{{(dataDetailOrder.empresa_id == null ||  dataDetailOrder.empresa_id =='') ? 'Particular' : dataDetailOrder.company}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list class="py-0">
                                                    <v-list-item >
                                                        <v-list-item-avatar >
                                                        <v-icon color="primary">mdi-36px mdi-check-circle-outline</v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-content>
                                                        <v-list-item-title>Estado</v-list-item-title>
                                                        <v-list-item-subtitle>{{state}}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                            <v-col 
                                                cols="12"
                                                md="8"
                                            >
                                                <v-simple-table 
                                                    dense 
                                                >
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                            <th class="text-left">Examenes</th>
                                                            <th class="text-center">Proveedor</th>
                                                            <th class="text-center">Resultados</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(detail, x) in dataDetailOrder.details" :key="x">
                                                            
                                                                <td style="boder:1px solid">{{detail.desc_item}}</td>
                                                                <td 
                                                                    style="border: 1px solid silver;" 
                                                                    class="text-center"
                                                                    v-if="detail.print" 
                                                                    :rowspan="detail.rowspan"
                                                                >
                                                                {{detail.proveedor}}
                                                                </td>
                                                                <td 
                                                                    style="border: 1px solid silver;width: 200px;padding: 5px;"
                                                                    class="text-center" 
                                                                    v-if="detail.print" 
                                                                    :rowspan="detail.rowspan"
                                                                >
                                                                    <v-btn 
                                                                        small 
                                                                        color="primary" 
                                                                        target="_blank" 
                                                                        @click="viewPdf(detail.archive.split('/')[detail.archive.split('/').length-1].toString(),'pdf')"
                                                                        v-if="detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'null.pdf'"
                                                                    >
                                                                        <v-icon>mdi-file-pdf</v-icon> Ver archivo
                                                                    </v-btn>
                                                                    <div v-else style="width:auto">
                                                                        <v-form>
                                                                            <v-checkbox
                                                                                v-model="detail.check"
                                                                                label="Agregar Logo y pie"
                                                                                @click=setHeaderFeet(detail)
                                                                            ></v-checkbox>
                                                                            <v-file-input
                                                                                :id=x.toString()
                                                                                accept="application/pdf"
                                                                                label="Archivo"
                                                                                name=file
                                                                                prepend-icon=''
                                                                                clear-icon='mdi-cancel'
                                                                                @click:clear=setFileCharge(detail)
                                                                                :append-icon="detail.fileCharged ? 'mdi-eye' : ''"
                                                                                @click:append="previewFile(detail.path,'temp')"
                                                                                dense
                                                                                @change=setFile($event,detail)
                                                                            ></v-file-input>
                                                                        </v-form>
                                                                    </div>
                                                                    <v-btn 
                                                                        small 
                                                                        class="mt-3"
                                                                        color="warning"
                                                                        v-if="detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'null.pdf'"
                                                                        @click=deleteFile(detail)
                                                                    >
                                                                        <v-icon>mdi-delete-forever</v-icon> Eliminar
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-col cols="12" class="text-center">
                                    <v-btn 
                                        color="primary" 
                                        class="mx-2" 
                                        @click=storeFile 
                                        v-if="1==1"
                                    >
                                        <v-icon>mdi-cloud-upload</v-icon> Cargar
                                    </v-btn>
                                    <v-btn color="secondary" class="mx-2" @click=closeDialogOrder>
                                        <v-icon>mdi-cancel</v-icon> Cerrar
                                    </v-btn>
                                </v-col>
                            </v-card>
                        </v-dialog> -->
                        </div>
                        <v-alert
                            v-else
                            color="red"
                            border="left"
                            elevation="2"
                            colored-border
                            icon="mdi-cancel"
                        >
                            No tiene permisos para listar las ordenes de laboratorio
                        </v-alert>
                </v-card>
               
            </v-container>
        </v-main>
        <div v-else>No tiene acceso a esta vista</div>
    </v-app>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import NavAdministration from '../../base/NavPrivateComponent'
    import DetailOrderComponent from '../../base/DetailOrderComponent'
    import StatusOrderComponent from '../../base/StatusOrderComponent'
    import axios from 'axios'

    export default {
        name:'AdminOrdersComponent',
        components:{
            NavAdministration,
            DetailOrderComponent,
            StatusOrderComponent
        },
        data: ()=> ({
            dates: [],
            menu: true,
            dialogOrder:false,
            dialogPreviewPdf:false,
            overlay:false,
            cotizar:false,
            stateListOrder:'OLST_SOLICITADA',
            filePriview:'',
            company:'',
            totalItems: 0,
            state:'',
            rowIncrement:0,
            providers:[],
            file:[],
            companies:[],
            olabsQuote:[],
            dataDetailOrder:{
                order:'',
                patient:'',
                doctor:'',
                date:'',
                identification:'',
                company:'',
                empresa_id:'',
                email:'',
                details:[]
            },
            dataDefaultDetailOrder:{
                order:'',
                patient:'',
                doctor:'',
                date:'',
                company:'',
                empresa_id:'',
                identification:'',
                email:'',
                details:[]
            },
            dataTable: [],
            search:'',
            options: {},
            headers: [
                /* { text: 'Cotizar', value: 'cotizar' }, */
                { text: 'Nº Orden', value: 'olab_id' },
                { text: 'Cotización', value: 'quote_id' },
                { text: 'Cliente', value: 'cliente' },
                { text: 'Paciente', value: 'paciente' },
                { text: 'Médico', value: 'doctor' },
                { text: 'Fecha', value: 'olab_fecha' },
                { text: 'Estado', value: 'status' },
                { text: 'Acción', value: 'action' }
            ],
        }),
        watch: {     
            options: {
                handler () {
                    this.getDataComponent()
                }, 
                deep: true,
            },
        },
        computed:{
            ...mapState([
                'idActionsRol',
                'loadingTable',
                'user',
                'url',
                'statesListOrder',
                'pathFileOrder',
                'directoryPDF',
                'directoryTemp',
                'directoryComplement',
                'urlApi',
                'token'
            ]),

            dateRangeText () {
                return this.dates.join(' ~ ')
            },

            accessAdmin (){
                return typeof this.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined";
            },

            listOrders (){
                return typeof this.idActionsRol.find(e => e === 'LISTAR_ORDENES') != "undefined";
            },
        },
        methods: {
            ...mapMutations(['setLoadingTable','setUrl','setNotifications']),

            ...mapActions(['requestApi','alertNotification','getNotifications']),

            setFile(data,detail){
                if(typeof data != 'undefined'){
                    this.overlay= true
                    let formData = new FormData();
                    formData.append('file_0',data)
                    formData.append('directory', this.directoryTemp)
                    formData.append('data', JSON.stringify([detail]))
                    formData.append('preview',true)
                    formData.append('pathCompleMent',this.directoryComplement)
                    this.setUrl('ordenes-laboratorio')
                    axios.post(
                        this.url,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Authorization': 'Bearer '+ this.token
                            }
                        }
                    ).then(res=>{
                        let obj = this.file.find(e => e.proveedor_id == detail.proveedor_id && e.order_id === detail.olab_id)
                        if(typeof obj != 'undefined'){
                            this.file[this.file.indexOf(obj)].file = data
                            this.file[this.file.indexOf(obj)].check = detail.check
                        }else{
                            this.file.push({
                                file: data,
                                proveedor_id: detail.proveedor_id,
                                order_id: detail.olab_id,
                                check : detail.check
                            })
                        }
                        let index = this.dataDetailOrder.details.indexOf(detail)
                        this.dataDetailOrder.details[index].path= res.data[0].file
                        this.dataDetailOrder.details[index].fileCharged=true
                        this.overlay= false
                    
                    }).then(()=>{
                        this.overlay= false
                    })
                    
                }
            },

            setFileCharge(detail){
                let index = this.dataDetailOrder.details.indexOf(detail)
                this.dataDetailOrder.details[index].fileCharged=false
            },

            setHeaderFeet(detail){
                let obj = this.file.find(e => e.proveedor_id == detail.proveedor_id && e.order_id === detail.olab_id)
                if(typeof obj != 'undefined')
                    this.file[this.file.indexOf(obj)].check = detail.check
            },

            searchDataTable(){
                this.getDataComponent()
            },

            getDataComponent(){

                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                let resetPage = page > 1 && (this.company != '' || this.search !='')
                
                let party_type_id= ''
                this.setLoadingTable(true)
                this.setUrl('ordenes-laboratorio')
                this.requestApi({
                    method:'GET',
                    data:{
                        page: resetPage ? 1 : page,
                        itemsPerPage: itemsPerPage,
                        search:this.search,
                        dates: this.dateRangeText,
                        party_id: this.company,
                        stateOrder : this.stateListOrder,
                        party_type_id: typeof this.companies.find(e => e.party_id == this.company) != 'undefined' 
                                                ? this.companies.find(e => e.party_id == this.company).party_type_id 
                                                : '',
                    }
                }).then(res=>{
                    console.log(res)
                    let items = res.data._embedded.ordenes_laboratorio
                    this.cotizar = items.filter(e => e.cotizar == true ).length>0
                    this.totalItems= res.data.total_items
                    this.dataTable= items
                    const total = items.length

                    if (sortBy.length === 1 && sortDesc.length === 1) {
                        items = items.sort((a, b) => {
                            const sortA = a[sortBy[0]]
                            const sortB = b[sortBy[0]]

                            if (sortDesc[0]) {
                                if (sortA < sortB) return 1
                                if (sortA > sortB) return -1
                                return 0
                            } else {
                                if (sortA < sortB) return -1
                                if (sortA > sortB) return 1
                                return 0
                            }
                        })
                    }

                    if (itemsPerPage > 0) {
                        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                    }
                    this.setLoadingTable(false)
                  

                })

            },

            detailOrder(item){
                this.setLoadingTable(true)
                this.setUrl('ordenes-laboratorio/'+item.olab_id)
                this.dataDetailOrder.order= "#"+item.olab_id
                this.dataDetailOrder.patient= item.paciente
                this.dataDetailOrder.doctor= item.doctor
                this.dataDetailOrder.date= item.olab_fecha
                this.dataDetailOrder.identification = item.identification
                this.dataDetailOrder.empresa_id = item.empresa_id
                this.dataDetailOrder.email = item.email
                this.requestApi({
                    method:'GET',
                    data:{}
                }).then(res=>{
                    console.log(res)
                    let proveedor_id = ''
                    let x=0
                    let rowspan = ''
                    let archive =''
                    this.dataDetailOrder.company =  res.data.company
                    this.dataDetailOrder.details = res.data.items.map((obj)=>{
                        let print = proveedor_id != obj.proveedor_id
                        obj.proveedor=[]
                        if(print){
                            rowspan = typeof res.data.rowspan[x] != 'undefined' ? res.data.rowspan[x].rowspan  : ''
                            archive = typeof res.data.rowspan[x] != 'undefined' ? this.pathFileOrder+res.data.rowspan[x].ruta_documento+'.pdf'  : ''
                            if(typeof res.data.rowspan[x] != 'undefined')
                                obj.proveedor= res.data.rowspan[x].group_name

                            obj.path='sdsd'
                            obj.olab_id = item.olab_id
                            x++
                        }else{
                            archive=false
                        }
                        obj.check = false
                        obj.print = print
                        obj.rowspan = rowspan
                        obj.archive = archive
                        proveedor_id = obj.proveedor_id
                        obj.fileCharged= false
                        return obj
                    })
                    this.dialogOrder=true
                    const match = e => e.status_id === "OLIT_SOLICITADO"
                    let stateOrder = res.data.items.find(match)
                    typeof stateOrder != 'undefined'
                        ? this.state= "Solicitado" 
                        : this.state= "Completado" 

                    this.setLoadingTable(false)
                   
                })
               
            },

            storeFile(emit){
                console.log('guadó: '+ emit)
                if(emit)
                    this.getDataComponent()
                /* this.setUrl('ordenes-laboratorio')
                this.overlay= true
                let formData = new FormData();
                let arr =[]
                this.file.map((data,x) => {
                    formData.append('file_'+x,data.file)
                    arr.push(data)
                })
                
                formData.append('data', JSON.stringify(arr))
                formData.append('directory', this.directoryPDF)
                formData.append('directoryTemp', this.directoryTemp)
                formData.append('preview',false)
                formData.append('pathCompleMent',this.directoryComplement)
                formData.append('log', JSON.stringify({
                    userLoginId : this.user.user_ligin_id,
                    system: 'laboratorio',
                    dataBase: 'obinnoclinica'
                }))
                axios.post(
                    this.url,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ this.token
                        }
                    }
                ).then(res=>{
                    console.log(res.data)
                    for(let i in res.data){
                        let obj =  this.dataDetailOrder.details.find(e=> e.proveedor_id == res.data[i].provider && e.print )
                        if(typeof obj != 'undefined')
                            obj.archive = this.pathFileOrder+res.data[i].file
                    }              
                    this.getDataComponent()
                    this.overlay= false     
                }).then(()=>{
                    this.overlay= false
                }) */
            },

            getCompanies(){
                this.setUrl('ordenes-laboratorio/1')
                this.requestApi({
                    method: 'DELETE',
                    data:{}
                })
                .then(res=>{
                   
                    this.companies= res.data.detail
                  
                    this.companies.unshift({
                        name:'Seleccione una empresa',
                        party_type_id: 0,
                        party_id: ''
                    },{
                        name:'Particulares',
                        party_type_id:'',
                        party_id: 0
                    })
                    
                })
            },

            previewFile(archive,binder){
                window.open(this.urlApi+'file.php?file='+binder+'/'+archive)
            },

            deleteFile(detail){
                this.overlay= true
                this.setUrl('ordenes-laboratorio')
                this.overlay= true
                this.requestApi({
                    method: 'DELETE',
                    data:{
                        archive: detail.archive.split("/")[detail.archive.split("/").length-1],
                        olab_id : detail.olab_id,
                        proveedor_id: detail.proveedor_id,
                        directory : this.directoryPDF,
                        userLoginId : this.user.user_ligin_id,
                        system: 'laboratorio',
                        dataBase: 'obinnoclinica'
                    }
                }).then(res=>{
                    this.overlay= false
                    this.alertNotification({
                        param:{
                            html : res.detail
                        }
                    })
                    let obj =  this.dataDetailOrder.details.find(e=> e.proveedor_id == detail.proveedor_id && e.print )
                    if(typeof obj != 'undefined')
                        obj.archive = this.pathFileOrder+'null.pdf'

                    this.state= "Solicitado" 
                    this.overlay= false
                    this.getDataComponent()
                }).then(()=>{
                     this.overlay=false
                })
            },

            closeDialog(state){
                this.dialogOrder=state
                Object.assign(this.dataDetailOrder,this.dataDefaultDetailOrder)
                this.file=[]
            },
            
            /* closeDialogOrder(){
                this.dialogOrder=false
                Object.assign(this.dataDetailOrder,this.dataDefaultDetailOrder)
                this.file=[]
            }, */

            LoadOrder(data){
                this.dates = [
                    new Date(data.olab_fecha).toISOString().substr(0, 10),
                    new Date(data.olab_fecha).toISOString().substr(0, 10),
                ]
                this.stateListOrder = 'OLST_SOLICITADA'
                this.company = data.empresa_id == null ? '' : data.empresa_id
                this.search = data.olab_id
                this.getDataComponent()
            },

            LoadCompany(data){
                console.log(data, data.empresa_id == '' )
                this.dates = [
                    new Date(data.fecha_min).toISOString().substr(0, 10),
                    new Date(data.fecha_max).toISOString().substr(0, 10),
                ]
                this.search= ''
                console.log(this.company)
                this.stateListOrder = ''
                this.company.party_id=  data.empresa_id == '' ? 0 : data.empresa_id
                
                this.getDataComponent()
            },
        
            viewPdf(detail,binder){
                window.open(this.urlApi+'file.php?file='+binder+'/'+detail)
                this.setUrl('ordenes-laboratorio/1')
                this.requestApi({
                    method: 'PUT',
                    data:{
                        preview : 'irewniubn',
                        file :detail,
                        userLoginId : this.user.user_ligin_id,
                        system: 'laboratorio',
                        dataBase: 'obinnoclinica',
                        comment: this.user.user_ligin_id+' se ha descargado el archivo '+detail
                    }
                }).then(res=>{
                    
                })
            },

            setOverlay(state){
                console.log(state)
                this.overlay= state
            },

            setState(state){
                this.state = state
            },

            updateStatusOrder(data){
            
                let order = this.dataTable.find(e => e.olab_id == data.idOrder)
                console.log(order,data )
                if(typeof order != 'undefined'){
                    if(data.status){
                        order.status_id_order= 'OLST_CANCELADA'
                        order.status = 'Cancelada'
                    }else{  
                        order.status_id_order= 'OLST_SOLICITADA'
                        order.status = 'solicitada'
                    }
                }
                this.getDataComponent()
               // console.log(this.dataTable,data)
            }
        },
        created(){
            let d = new Date()
            let month = d.setMonth(d.getMonth()-1)
            let dd = new Date(month).toISOString().substr(0, 10)
            this.dates = [
                dd,
                new Date().toISOString().substr(0, 10)
            ]
            this.getCompanies()
        },
        mounted(){
            this.getNotifications().then(res =>{
                this.setNotifications(res)
            })
            this.statesListOrder.push({status_id : 'OLST_CANCELADA' , name : 'Canceladas'})
        }

    }
</script>

<style scope>
    label.v-label{
        position: relative!important;
    }

    @media(max-width: 600px){
        #app > div > main > div > div > div > div > div.v-data-table.elevation-3.theme--light > div.v-data-table__wrapper > table > thead > tr > th > div,
        #app > div > main > div > div > div > div > div.v-data-table.elevation-3.theme--light > div.v-data-table__wrapper > table > thead{
            display: none;
        }
        .v-text-field{
            padding-top: 0px!important;
            margin-top: 0px!important;
        }
        .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
            border-bottom: thin solid rgb(0 0 0)!important;
        }
    }
</style>